import AsyncStorage from '@react-native-async-storage/async-storage'

import { queryClient } from '../queryClient'

import { QueryKey } from '~utils'

// 1. We are encrypting data with this approach:
// - ["QUERY_KEY" + "hashCode" + "VARIABLES"]: data
// 2. We store it in the AsyncStorage
// 3. App on start is fetching and decrypting this data
export const hashCode = '#<1#'

export const writeToStorageCacheQuery = async (queryKey: QueryKey, data: object): Promise<void> => {
  const [key, variables] = queryKey || ['', undefined]

  const stringifiedVariables = JSON.stringify(variables)
  let storageData = await AsyncStorage.getItem('queriesWithVariables')

  if (variables) {
    storageData = {
      ...JSON.parse(storageData ?? '{}'),
      [`${key}${hashCode}${stringifiedVariables}`]: data,
    }
  } else {
    storageData = {
      ...JSON.parse(storageData ?? '{}'),
      [`${key}`]: data,
    }
  }

  await AsyncStorage.setItem('queriesWithVariables', JSON.stringify(storageData))
}

export const clearStorageCacheQueries = async (): Promise<void> => {
  const storageDataWithVariables = await AsyncStorage.getItem('queriesWithVariables')
  if (storageDataWithVariables) {
    await AsyncStorage.removeItem('queriesWithVariables')
  }
}

// Hydrate from localStorage
export const readFromStorageCacheQuery = async (): Promise<void> => {
  const storageDataWithVariables = await AsyncStorage.getItem('queriesWithVariables')
  if (storageDataWithVariables !== null) {
    const queriesWithData = JSON.parse(storageDataWithVariables)

    for (const queryKey in queriesWithData) {
      const data = queriesWithData[queryKey]
      if (queryKey.includes(hashCode)) {
        const [key, stringifiedVariables] = queryKey.split(hashCode)

        queryClient.setQueryData([key, JSON.parse(stringifiedVariables)], data)
      } else {
        queryClient.setQueryData([queryKey], data)
      }
    }
  }
}
